var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _g, _path49;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoteSignRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 137,
    viewBox: "0 0 77 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9199 124.823C37.9199 124.823 29.6312 120.964 27.9035 118.703C27.3236 116.584 33.7962 118.059 33.7962 118.059L37.9199 124.823Z",
    fill: "#D6B991"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6782 97.6437C21.6782 97.6437 23.2265 95.2036 30.9823 97.267C33.8374 99.3332 30.011 102.58 30.011 102.58L21.6782 97.6437Z",
    fill: "#C09868"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3201 117.615L30.496 117.438L30.0145 106.046L25.8386 106.222L26.3201 117.615Z",
    fill: "#C09868"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9143 106.001C22.9143 106.001 24.2094 104.505 27.6267 104.423C28.6451 106.207 27.7974 107.628 27.7974 107.628L22.9143 106.001Z",
    fill: "#C09868"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2184 101.791C32.5275 102.559 34.0375 103.687 34.0375 103.687L29.1132 117.073L37.9169 124.826C37.9169 124.826 46.5293 128.335 51.9246 124.411C54.6561 117.559 53.8466 107.766 53.8466 107.766C53.8466 107.766 40.9663 99.9986 38.7205 99.0332C36.4717 98.0678 35.9478 97.5468 30.0904 97.1229",
    fill: "#D6B991"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3538 107.999C32.5717 111.864 37.9345 114.301 43.4858 115.49C44.2452 115.646 45.3313 115.876 46.0937 115.97C46.5322 116.037 46.9737 116.111 47.4182 116.196C46.5264 116.255 45.6198 116.329 44.725 116.294C40.2069 116.146 35.6976 114.631 32.086 111.887C30.6496 110.795 29.2986 109.538 28.3538 107.999Z",
    fill: "#D6B991"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9707 70.0764L26.0249 125.806L33.4062 126.328L37.352 70.599L29.9707 70.0764Z",
    fill: "#F2C744"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2871 71.5562L37.0928 74.2847C33.9375 74.0139 30.4289 74.4613 29.4929 76.8572L29.905 71.0322L37.2871 71.5562Z",
    fill: "#F2C744"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7977 72.5954C55.5682 72.5954 71.5954 56.5682 71.5954 36.7977C71.5954 17.0272 55.5682 1 35.7977 1C16.0272 1 0 17.0272 0 36.7977C0 56.5682 16.0272 72.5954 35.7977 72.5954Z",
    fill: "#F2C744"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0802 23.6787C67.9014 25.6302 68.5431 27.6729 68.9875 29.7804",
    stroke: "#F2C744",
    strokeWidth: 4.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1348 2.96289C49.5287 3.74878 59.2184 10.0771 64.752 19.131",
    stroke: "#F2C744",
    strokeWidth: 4.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7978 68.6889C53.4112 68.6889 67.6896 54.4104 67.6896 36.7971C67.6896 19.1837 53.4112 4.90527 35.7978 4.90527C18.1845 4.90527 3.90601 19.1837 3.90601 36.7971C3.90601 54.4104 18.1845 68.6889 35.7978 68.6889Z",
    fill: "#F2C744"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7977 66.7497C52.3398 66.7497 65.7498 53.3396 65.7498 36.7976C65.7498 20.2555 52.3398 6.84546 35.7977 6.84546C19.2556 6.84546 5.84558 20.2555 5.84558 36.7976C5.84558 53.3396 19.2556 66.7497 35.7977 66.7497Z",
    fill: "#F3F4F5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6374 17.2537L37.3254 21.6364L35.9744 21.5393L30.2818 34.8082L25.3752 34.4608L21.6105 20.5238L20.2595 20.4267L20.5715 16.0439L27.2943 16.5208L26.9823 20.9035L26.3759 20.8594L28.2332 28.9213L31.209 21.2008L30.6026 21.1566L30.9146 16.7739L37.6374 17.2507V17.2537Z",
    fill: "#265CA9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8813 20.8854L51.9659 33.7922L49.202 36.1499L40.9723 35.5671L38.5675 32.8415L39.48 19.9376L42.2468 17.58L50.4765 18.1628L52.8813 20.8854Z",
    fill: "#CD2027"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0829 37.2871L35.7094 38.3938L35.2385 45.0489L30.8087 44.7339L30.9705 42.4616L29.802 42.3792L29.1486 51.6186L30.273 51.698L29.9639 56.0602L23.2853 55.5863L23.5944 51.2242L24.7188 51.3036L25.3722 42.0643L24.2037 41.9819L24.0418 44.2542L19.6119 43.9392L20.0829 37.2842V37.2871Z",
    fill: "#CD2027"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4477 45.9134L47.6096 43.6411L42.9561 43.3114L42.7854 45.7397L46.6295 46.0135L46.3204 50.3756L42.4763 50.1018L42.3026 52.5537L46.8443 52.8745L47.0033 50.6258L51.4772 50.9437L51.0092 57.5546L36.5071 56.5273L36.8161 52.1652L37.9405 52.2446L38.594 43.0053L37.4696 42.9258L37.7816 38.5431L47.0445 39.1995L47.8627 40.0943L47.9216 39.2613L52.2837 39.5703L51.8128 46.2254L47.4507 45.9163L47.4477 45.9134Z",
    fill: "#265CA9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1056 21.4834L46.5648 23.3319L48.4662 23.4673L46.8503 24.4768L47.3094 26.3282L45.8495 25.1008L44.2306 26.1104L44.9459 24.3414L43.486 23.114L45.3903 23.2494L46.1056 21.4834Z",
    fill: "#F3F4F5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6787 27.5117L46.1379 29.3602L48.0393 29.4956L46.4234 30.5052L46.8826 32.3566L45.4226 31.1292L43.8038 32.1388L44.519 30.3698L43.0591 29.1424L44.9635 29.2778L45.6787 27.5117Z",
    fill: "#F3F4F5"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9264 77.2312L32.5952 110.998",
    stroke: "#F2C744",
    strokeWidth: 4.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2892 115.405L32.0508 118.878",
    stroke: "#F2C744",
    strokeWidth: 4.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4437 113.623C95.958 112.867 64.6137 111.949 53.8437 107.766C46.2085 104.152 51.9217 124.411 51.9217 124.411C51.9217 124.411 86.3713 132.399 92.5966 135.516C96.3377 126.839 96.4407 113.623 96.4407 113.623H96.4437Z",
    fill: "#D6B991"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9001 117.123C67.4276 118.159 64.7491 117.167 62.2237 116.841C60.231 116.423 57.1228 116.384 55.8954 114.498C55.7217 114.206 55.6157 113.879 55.5863 113.556C56.0955 114.795 57.3641 115.201 58.5709 115.407C59.816 115.593 61.1111 115.722 62.3679 115.925C64.9022 116.267 67.2775 117.417 69.8971 117.123H69.9001Z",
    fill: "#D6B991"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M69.223 120.829C68.2752 119.916 67.0184 119.678 65.7733 119.439C64.5106 119.213 63.245 118.977 61.9881 118.724C60.7342 118.477 59.4627 118.2 58.2265 117.938C57.6201 117.823 57.0138 117.753 56.4486 117.909C55.8894 118.062 55.339 118.447 55.1447 119.077C55.1359 118.75 55.2654 118.412 55.4744 118.138C56.116 117.27 57.3523 117.114 58.3265 117.223C59.6363 117.361 60.8991 117.564 62.1706 117.817C63.4392 118.071 64.6961 118.38 65.9411 118.742C67.1656 119.101 68.5784 119.648 69.223 120.829Z",
    fill: "#D6B991"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1883 106.024C26.8409 105.824 26.4318 105.741 26.0315 105.65C25.0307 105.423 23.5826 105.229 22.8202 106.097C22.6289 106.315 22.5082 106.586 22.4435 106.866C22.4082 107.019 22.3905 107.178 22.3905 107.334C22.3993 108.172 22.9733 108.843 23.6179 109.314C24.4185 109.9 25.381 110.303 26.3376 110.554C26.4465 110.583 26.5407 110.601 26.6555 110.58C26.8292 110.548 26.9822 110.442 27.1 110.309C27.3295 110.056 27.5267 109.715 27.6827 109.412C27.8505 109.091 27.9771 108.749 28.0507 108.393C28.1861 107.728 28.0566 106.957 27.6386 106.412C27.5091 106.244 27.3531 106.118 27.1853 106.018L27.1883 106.024Z",
    fill: "#D6B991"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0852 106.842C27.0852 106.842 27.6091 108.541 26.5348 109.936C24.8452 109.533 24.6951 109.371 24.6951 109.371C24.4832 109.012 24.8747 107.037 25.2308 106.881C26.1168 106.766 27.0822 106.845 27.0822 106.845L27.0852 106.842Z",
    fill: "#CFABA1"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2655 106.569C24.4215 107.419 24.1448 108.137 23.6974 108.853C23.1176 108.137 23.4973 106.99 24.2655 106.569Z",
    fill: "#D6B991"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1949 99.1568C27.8888 98.9007 27.5003 98.7477 27.1235 98.5858C26.1787 98.1855 22.5877 96.9198 21.6812 97.6409C21.4545 97.8205 21.2897 98.0648 21.1749 98.3326C21.1131 98.4769 21.0689 98.6299 21.0425 98.7859C20.9041 99.613 21.3515 100.375 21.9019 100.952C22.5877 101.67 25.6665 103.057 26.5613 103.472C26.6644 103.519 26.7527 103.554 26.8704 103.554C27.047 103.554 27.2177 103.475 27.3561 103.366C27.6269 103.157 27.88 102.857 28.089 102.586C28.3097 102.3 28.4952 101.985 28.6306 101.647C28.8807 101.014 28.8896 100.234 28.5717 99.6248C28.4746 99.4364 28.345 99.2834 28.192 99.1568H28.1949Z",
    fill: "#D6B991"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9476 99.9485C27.9476 99.9485 28.1625 101.712 26.8645 102.898C25.2721 102.203 25.1543 102.018 25.1543 102.018C25.0101 101.629 25.7401 99.7513 26.1198 99.66C27.0116 99.7042 27.9506 99.9485 27.9506 99.9485H27.9476Z",
    fill: "#CFABA1"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M25.222 99.1807C25.2279 100.046 24.8276 100.702 24.2595 101.329C23.815 100.523 24.389 99.4603 25.222 99.1807Z",
    fill: "#D6B991"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8946 98.4592C23.9005 99.3246 23.5002 99.981 22.9321 100.608C22.4877 99.8014 23.0616 98.7389 23.8946 98.4592Z",
    fill: "#D6B991"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1617 110.78C27.0793 110.706 26.988 110.644 26.8791 110.597C26.679 110.512 26.4729 110.426 26.2669 110.353C25.7842 110.179 25.2779 110.047 24.7628 110.02C23.7002 109.967 22.8584 110.491 22.5641 111.536C22.2227 112.746 22.9821 113.679 23.9975 114.229C24.4126 114.453 24.8541 114.624 25.3044 114.762C25.6517 114.868 26.0285 115.024 26.3994 114.965C26.7643 114.909 26.9969 114.721 27.1882 114.424C27.3471 114.176 27.4855 113.914 27.5885 113.638C27.8505 112.946 27.8769 112.19 27.6032 111.498C27.4943 111.227 27.3677 110.965 27.1588 110.777L27.1617 110.78Z",
    fill: "#D6B991"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7555 111.386C26.7555 111.386 27.2618 112.996 26.3258 114.28C25.1072 114.024 24.7746 113.87 24.7746 113.87C24.6362 113.388 25.1337 111.819 25.3898 111.339C26.0138 111.233 26.7584 111.386 26.7584 111.386H26.7555Z",
    fill: "#CFABA1"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7569 110.972C24.6833 111.943 24.4478 112.761 24.0004 113.627C23.4029 112.741 23.8003 111.404 24.7569 110.972Z",
    fill: "#D6B991"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8351 118.639C26.8351 118.639 28.0477 118.78 28.0419 116.855C28.036 114.93 26.3317 114.903 26.3317 114.903C26.3317 114.903 25.3222 114.927 25.4546 116.716C25.59 118.503 26.8351 118.639 26.8351 118.639Z",
    fill: "#D6B991"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9323 115.643C27.1295 115.669 27.3708 116.219 27.4091 116.34C27.5769 116.838 27.5003 117.373 27.3061 117.85C27.256 117.977 27.1854 118.274 27.0059 118.253C26.8734 118.239 26.7822 118.015 26.738 117.906C26.6791 117.768 26.6438 117.618 26.6114 117.47C26.5114 117.017 26.479 116.496 26.6291 116.049C26.6703 115.922 26.7498 115.734 26.8646 115.66C26.8852 115.646 26.9087 115.643 26.9323 115.646V115.643Z",
    fill: "#CFABA1"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0551 115.557C26.2022 116.472 26.1757 117.164 26.2817 118.056C25.4575 117.544 25.4252 116.234 26.0551 115.557Z",
    fill: "#D6B991"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6576 127.296C78.3211 132.703 100.576 135.363 122.905 135.216C122.858 128.32 122.814 121.426 122.766 114.53C102.174 114.668 81.6471 112.214 61.6673 107.224C59.9984 113.915 58.3265 120.605 56.6576 127.293V127.296Z",
    fill: "#E2E2E2"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1976 129.745C80.0664 134.701 101.459 137.136 122.914 136.994C122.861 128.915 122.805 120.832 122.752 112.752C103.237 112.882 83.781 110.668 64.7989 106.159C62.9299 114.021 61.0638 121.883 59.1947 129.745H59.1976Z",
    fill: "#265CA9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3046 112.413C69.1847 112.605 70.0441 112.057 70.2237 111.201C70.4032 110.341 69.844 109.5 68.9786 109.311C68.1133 109.123 67.2538 109.658 67.0625 110.515C66.8711 111.372 67.4245 112.225 68.3046 112.413Z",
    fill: "#64A3E2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8844 110.45C68.8462 110.63 68.961 110.806 69.1434 110.844C69.3259 110.883 69.5025 110.771 69.5408 110.591C69.5791 110.412 69.4613 110.238 69.2818 110.197C69.0993 110.159 68.9227 110.27 68.8844 110.45Z",
    fill: "#124875"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9337 110.241C67.8955 110.421 68.0103 110.597 68.1928 110.635C68.3753 110.674 68.5519 110.562 68.5931 110.385C68.6313 110.206 68.5165 110.029 68.334 109.991C68.1516 109.953 67.975 110.064 67.9337 110.241Z",
    fill: "#124875"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6902 111.333C68.6519 111.512 68.7667 111.689 68.9492 111.727C69.1317 111.765 69.3113 111.654 69.3495 111.474C69.3878 111.295 69.2701 111.118 69.0905 111.08C68.908 111.041 68.7285 111.153 68.6902 111.333Z",
    fill: "#124875"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7395 111.127C67.7013 111.306 67.8161 111.483 67.9985 111.521C68.181 111.562 68.3606 111.447 68.3989 111.271C68.4371 111.091 68.3223 110.915 68.1398 110.876C67.9573 110.835 67.7778 110.95 67.7395 111.127Z",
    fill: "#124875"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8467 107.766C53.8467 107.766 52.4044 99.5538 44.834 94.3969C40.987 91.4859 39.4387 87.1032 39.3593 86.5027C39.2739 85.8522 37.7316 83.7447 36.3864 84.7661C35.0413 85.7845 35.3445 88.0156 35.3562 88.5867C35.368 89.1577 37.0546 94.6236 40.5396 98.8356C42.9384 102.265 42.803 104.375 42.803 104.375C42.803 104.375 46.3675 109.22 53.8438 107.769L53.8467 107.766Z",
    fill: "#D6B991"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3321 95.5182C45.6492 96.3924 44.6337 96.8751 43.6742 97.3608C43.8508 96.2011 45.2313 95.4564 46.3321 95.5182Z",
    fill: "#D6B991"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1336 97.1822C47.698 98.0152 46.9297 98.4096 46.0791 98.7246C46.1174 97.768 47.2447 97.1027 48.1336 97.1822Z",
    fill: "#D6B991"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1781_489",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 84,
    width: 19,
    height: 25
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8467 107.766C53.8467 107.766 52.4044 99.5538 44.834 94.3969C40.987 91.4859 39.4387 87.1032 39.3593 86.5027C39.2739 85.8522 37.7316 83.7447 36.3864 84.7661C35.0413 85.7845 35.3445 88.0156 35.3562 88.5867C35.368 89.1577 37.0546 94.6236 40.5396 98.8356C42.9384 102.265 42.803 104.375 42.803 104.375C42.803 104.375 46.3675 109.22 53.8438 107.769L53.8467 107.766Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1781_489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.6677 85.3282C38.6677 85.3282 37.6051 86.2996 38.132 88.2687C38.6618 90.2378 38.8443 90.2467 38.8443 90.2467L40.5249 89.0899C40.5249 89.0899 40.3483 85.8257 38.6677 85.3282Z",
    fill: "#CFABA1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6139 100.569C42.803 103.327 44.8546 105.447 47.0651 107.395C47.3888 107.681 47.7244 107.954 48.0393 108.281C44.7103 107.43 41.3902 104.184 41.6168 100.566L41.6139 100.569Z",
    fill: "#D6B991"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoteSignRight);
export default __webpack_public_path__ + "static/media/VoteSignRight.4e3d9b8fa67d32f6bb76c22d2ded55b4.svg";
export { ForwardRef as ReactComponent };